import React from "react";
import { Link } from "react-router-dom";
import { categoryById, formatDate } from "@/data/articles";

export default function ArticleCard({ article, variant = "default" }) {
  const cat = categoryById(article.category);
  return (
    <article className={`news-card news-card-${variant}`} data-testid={`news-card-${article.slug}`}>
      <Link to={`/news/${article.slug}`} className="news-card-media" aria-label={article.title}>
        <img
          src={article.image}
          srcSet={article.imageSrcSet}
          sizes={variant === "featured" ? "(min-width: 900px) 900px, 100vw" : "(min-width: 900px) 420px, 100vw"}
          alt={article.imageAlt}
          loading="lazy"
          decoding="async"
          width="800"
          height="500"
        />
      </Link>
      <div className="news-card-body">
        <div className="news-card-meta">
          <Link to={`/news?cat=${article.category}`} className="news-cat-chip" data-testid={`news-card-cat-${article.slug}`}>
            {cat?.label}
          </Link>
          <span className="news-card-date">{formatDate(article.date)} · {article.readTime} read</span>
        </div>
        <h3 className="news-card-title">
          <Link to={`/news/${article.slug}`} data-testid={`news-card-link-${article.slug}`}>{article.title}</Link>
        </h3>
        <p className="news-card-excerpt">{article.excerpt}</p>
        <Link to={`/news/${article.slug}`} className="news-card-read" data-testid={`news-card-read-${article.slug}`}>
          Read article →
        </Link>
      </div>
    </article>
  );
}
